import './App.css';

import { CurrencyProvider } from './context/CurrencyContext';
import { ThemeProvider } from './context/ThemeContext';

import Router from './Roter';

function App() {
  return (
    <>
      <ThemeProvider>
        <CurrencyProvider>
          <Router />
        </CurrencyProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
